// GlobalSeconds
export const GLOBAL_SECONDS = "GLOBAL_SECONDS";
// GlobalMinutes
export const GLOBAL_MINUTES = "GLOBAL_MINUTES";
// GlobalHours
export const GLOBAL_HOURS = "GLOBAL_HOURS";
